// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ModalPrompt_wrapper__2VagY","content":"ModalPrompt_content__1BAfT","h1":"ModalPrompt_h1__39P0D typography_headline1__j8G8z"};